import Configs from "../config";
import { IUserByUidResponse } from "../types/UserTypes";
import { localStorageGetItem } from "../utils/LocalStorage";

export async function getAuthUser(
  userUid: string
): Promise<IUserByUidResponse | null> {
  const response: Response = await fetch(
    `${Configs.SERVER_URL}/user/info/${userUid}`
  );

  if (response.status === 200) {
    return response.json();
  }
  localStorage.clear();
  return null;
}

async function changePassword(
  oldPassword: string,
  newPassword: string
): Promise<boolean> {
  const token = localStorageGetItem("USER_TOKEN");

  let internalUid = localStorageGetItem("INTERNAL_USER_UID") as string;

  const response: Response = await fetch(
    `${Configs.SERVER_URL}/auth/change_password`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ oldPassword, newPassword, internalUid }),
    }
  );

  if (response.status === 200) {
    return true;
  } else {
    return false;
  }
}

export const AuthAPI = {
  changePassword,
};
